'use client';

import { ChevronsUpDown } from 'lucide-react';
import * as React from 'react';

import { CommandGroup } from 'cmdk';
import { Button } from './button';
import { Command, CommandEmpty, CommandInput, CommandItem } from './command';
import { Popover, PopoverContent, PopoverTrigger } from './popover';

export function Combobox({
  placeholder = 'Select an option...',
  ...props
}: {
  items?: { value: string; label: string }[];
  placeholder: string;
  onOptionSelection?: (value: string) => void;
}) {
  const [open, setOpen] = React.useState(false);
  const [value, setValue] = React.useState<string | null>(null);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          // biome-ignore lint/a11y/useSemanticElements: <explanation>
          role="combobox"
          aria-expanded={open}
          className="w-[200px] justify-between"
        >
          {value !== null
            ? props.items?.find((item) => item.value === value)?.label
            : placeholder}
          <ChevronsUpDown className="ml-2 size-4 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[200px] p-0">
        <Command>
          <CommandInput placeholder="Search..." />
          <CommandEmpty>No results found.</CommandEmpty>
          <CommandGroup className="h-64">
            {props.items?.map((item, i) => (
              <CommandItem
                key={item.value}
                value={item.value}
                onSelect={(currentValue) => {
                  props.onOptionSelection?.(currentValue);
                  setValue((val) =>
                    currentValue === val ? null : currentValue
                  );
                  setOpen(false);
                }}
                className="cursor-pointer"
              >
                {item.label}
              </CommandItem>
            ))}
          </CommandGroup>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
